import isEmpty from "lodash/isEmpty";
import Form from "../../components/Profile/Edit";
import { notify, notifySimple } from "../../themes/components/Notifications";
import { updateSelf } from "../../api/User";
import ChangePassword from "../../components/Profile/ChangePassword";
import { updatePassword } from "../../api/User";
import MainLayout from "../../themes/layouts/Main";
import FormStickyHeader from "../../components/FormStickyHeader";
import { Box } from "@mui/material";
import { isStrongPassword } from "../../utils/PasswordStrength";

const AccountRoute: React.FC = () => {
  const onSubmitUserEdit = async (values: UserUpdateVars) => {
    try {
      const response = await updateSelf(values);
      const { result, messages } = response.userUpdate;

      if (!isEmpty(messages)) {
        notify(messages);
      } else if (result) {
        notifySimple(["Details updated"], "success");
      }
    } catch (err) {
      notifySimple(["Error updating details"], "error");
    }
  };

  const onSubmitChangePassword = async (values: UserPasswordChangeVars) => {
    try {
      if (!isStrongPassword(values.password)) {
        notifySimple(["The password must be rated strong!"], "error");
        return;
      }
      const response = await updatePassword(values);
      const { result, messages } = response.userPasswordChange;

      if (!isEmpty(messages)) {
        notify(messages);
      } else if (result) {
        notifySimple(["Password updated"], "success");
      }
    } catch (err) {
      notifySimple(["Error updating password"], "error");
    }
  };

  return (
    <MainLayout>
      <FormStickyHeader>Account</FormStickyHeader>
      <Box sx={{ px: 4, py: 2.8, mt: 12 }}>
        <Form onSubmit={onSubmitUserEdit} />
        <ChangePassword onSubmit={onSubmitChangePassword} />
      </Box>
    </MainLayout>
  );
};

export default AccountRoute;
